import React from "react";

export type TranslateFunction = (key: string) => string;

export interface SdkProviderProps {
  t: TranslateFunction;
  children?: React.ReactNode;
}

export interface SdkContextValue {
  t: TranslateFunction;
}

export const SdkContext = React.createContext<SdkContextValue | null>(null);

const SdkProvider = (props: SdkProviderProps) => {
  const { t, children } = props;

  return <SdkContext.Provider value={{ t }}>{children}</SdkContext.Provider>;
};

const defaultTranslateFn = (key: string) => key;

export const useTranslate = () => {
  const context = React.useContext(SdkContext);
  if (!context) {
    return defaultTranslateFn;
  }
  return context.t;
};

export default SdkProvider;
